import { apiClient } from '@/lib/api-client';

import {
  availableNowPractitionerSchema,
  callablePractitionerSchema,
  startPortalCallResponseSchema,
  type AvailableNowPractitioner,
  type CallablePractitioner,
  type PortalHelplineRole,
  type StartPortalCallRequest,
  type StartPortalCallResponse,
} from '../types/schemas';

interface Envelope<T> {
  status: 'success' | 'error';
  message?: string;
  data: T;
}

export const portalHelplineService = {
  /**
   * GET /portal-helpline/practitioners?role=practitioner|volunteer
   * BE rate limit: 30/min/user; safe to poll at 5s.
   */
  async listCallable(role: PortalHelplineRole): Promise<CallablePractitioner[]> {
    const { data } = await apiClient.get<Envelope<unknown[]>>('/portal-helpline/practitioners', {
      params: { role },
    });
    return data.data.map((row) => callablePractitionerSchema.parse(row));
  },

  /**
   * GET /portal-helpline/available-now
   * Single resolved list — the server applies the full eligibility rule and
   * resolves the caller's location + BA from their token. No query params.
   */
  async listAvailableNow(): Promise<AvailableNowPractitioner[]> {
    const { data } = await apiClient.get<Envelope<unknown[]>>('/portal-helpline/available-now');
    return data.data.map((row) => availableNowPractitionerSchema.parse(row));
  },

  /**
   * POST /portal-helpline/start
   * BE rate limit: 5/min/user. Caller is responsible for debouncing.
   * On success the caller hands `data.id` to /sessions/:id/call/join.
   */
  async start(input: StartPortalCallRequest): Promise<StartPortalCallResponse> {
    const { data } = await apiClient.post<Envelope<unknown>>('/portal-helpline/start', input);
    return startPortalCallResponseSchema.parse(data.data);
  },
};
